import { render, staticRenderFns } from "./orderCourse.vue?vue&type=template&id=8083d2d4&scoped=true&"
import script from "./orderCourse.vue?vue&type=script&lang=js&"
export * from "./orderCourse.vue?vue&type=script&lang=js&"
import style0 from "./orderCourse.vue?vue&type=style&index=0&id=8083d2d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8083d2d4",
  null
  
)

export default component.exports